import React, { useState, useEffect, useContext } from 'react';



import { FaPlus } from "react-icons/fa";

import Loader from '../../components/loader/loader';
import { numberFormatter, totalFormatter } from '../../components/formatters/numberFormatter';
import { dateFormatter } from '../../dynamic/dateFormatter';
import toast from 'react-hot-toast';
import { isAuxFormatter, natureFormatter } from '../../components/formatters/defFormatter';
import { FiRotateCcw, FiPrinter } from "react-icons/fi";

import { Space, Input, Tag, Button, Tabs, Checkbox } from 'antd';
import { Modal, Col, Form, Row, DropdownButton, Dropdown, InputGroup } from 'react-bootstrap';


import Select from 'react-select';
import AsyncSelect from 'react-select/async';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcViewDetails, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiBarcodeReader } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../init/getData';




function DeliveryForm(props) {

  let { showModal, toggleModal, idRow, refreshTable, refAddeddelivery, setAddedDeliveryId } = props;


  const { userData, settingData, refData, api, deliveryTypeData, companyId, formLanguages } = useContext(DataContext);
  const userRole = userData.role;
  const createdBy = parseInt(userData.id);

  const [isLoading, setIsLoading] = useState(false);
  const [loadingEffect, setLoadingEffect] = useState(false);
  const [validated, setValidated] = useState(false);




  const today = new Date().toISOString().split('T')[0];


  const [delivery, setDelivery] = useState([]);



  const resetForm = () => {
    setDelivery({
      createdBy: createdBy,
      companyId: companyId,
    })
  }


  // idRow Change
  useEffect(() => {

    setDelivery(
      {
        name: idRow?.name || '',
        phone: idRow?.phone || '',
        companyId: companyId,
      }
    )
  }, [idRow, toggleModal]);


  // Generic handler for input changes
  const handleInputChange = (e) => {
    let { name, value } = e.target;
    if (value === 'true' || value === 'false') {
      value = JSON.parse(value)
    }
    setDelivery((prev) => ({
      ...prev,
      [name]: value,
    }));
  };





  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = document.getElementById('addForm');
    if (form.checkValidity() === false) {
      return;
    }


    setLoadingEffect(true);
    const data = {
      delivery,
      id: idRow?.id,
    }

    const operation = idRow ? 'edit' : 'add '
    try {
      let res = await api.post(`delivery/${operation}`, data);

      if (res.data.status) {
        if (refAddeddelivery) { refAddeddelivery() };
        toast.success(res.data.message);
        if (setAddedDeliveryId) {
          setAddedDeliveryId(res.data.deliveryId);
        }
        closeModal();
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error("Failed Contact Support");

      console.log('error' + error)
    } finally {
      setLoadingEffect(false);
      setValidated(false);
    }
  }

  const closeModal = () => {
    toggleModal();
    setValidated(false);
    const form = document.getElementById('addForm');
    form.reset();
    if (refreshTable) { refreshTable() };
  }


  return (
    <div>

      {isLoading &&
        <Loader />
      }


      {!isLoading &&
        <Modal show={showModal} size={'md'} onHide={toggleModal}>

          <Modal.Header style={{ background: "#23576a" }} className="modal-close-button" closeButton>
           <Modal.Title style={{ color: "white" }}>
            {idRow ? formLanguages.Edit : formLanguages.Add} {formLanguages.delivery}
          </Modal.Title>

          </Modal.Header>

          <Form validated={validated} id={'addForm'} onSubmit={handleSubmit} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); } }} >
            <Modal.Body className="custom-scrollbar" style={{ backgroundColor: '#f9fafa' }}>



              <Row className="mb-3">
                {/* Name  */}
                <Form.Group as={Col}>
                  <Form.Label className='formLabel'>{formLanguages.Name}<span style={{ color: 'red' }}> *</span></Form.Label>
                  <Form.Control type="text" name='name'
                    value={delivery.name}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Row>

              <Row className="mb-3">
                {/* Phone  */}
                <Form.Group as={Col}>
                  <Form.Label className='formLabel'>{formLanguages.Phone}<span style={{ color: 'red' }}> *</span></Form.Label>
                  <Form.Control type="text" name='phone'
                    value={delivery.phone}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Row>





            </Modal.Body>

            <Modal.Footer>
              <Button type="primary" loading={loadingEffect} htmlType="submit"
                onClick={() => setValidated(true)}
                style={{ marginLeft: '10px', backgroundColor: '#1d7790' }}>{formLanguages.Save}</Button>
            </Modal.Footer>

          </Form>
        </Modal >
      }

    </div >
  )
}

export default DeliveryForm;
